import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from '../i18n';

export default function NoteImportNotice() {
  const location = useLocation();
  const navigate = useNavigate();
  const [importedNote, setImportedNote] = useState(location.state?.importedNote || null);

  useEffect(() => {
    if (!location.state?.importedNote) return;
    setImportedNote(location.state.importedNote);
    const remainingState = { ...location.state };
    delete remainingState.importedNote;
    navigate(`${location.pathname}${location.search}`, { replace: true, state: remainingState });
  }, [location.pathname, location.search, location.state, navigate]);

  if (!importedNote) return null;
  return (
    <div className="notes-import-notice" role="status">
      <CheckCircle2 size={22} aria-hidden="true" />
      <span>{t('notes.importComplete', undefined, { title: importedNote.title })}</span>
      <button type="button" aria-label={t('common.close')} onClick={() => setImportedNote(null)}><X size={18} aria-hidden="true" /></button>
    </div>
  );
}
